import joinClasses from "helpers/joinClasses";

export function Line({className=""}) {
    return (
      <div className={joinClasses(className,"border border-grey-dark m-auto w-3/4 md:w-auto md:h-3/4 absolute left-1/2  -translate-x-1/2 top-1/2 transform md:-translate-y-1/2 ")} />
  
    )
  }